import { useSelectState, useSetState } from './selectors.js';
import {
  reduceResetToInfiniteZoom,
  reduceResetZoom,
} from '../../../core/components/interactions-state-helpers/reducers/reset-reducers.js';
import { reduceZoomDomain } from '../../../core/components/interactions-state-helpers/reducers/zoom-reducers.js';
import { useSynchronizedSelection } from '../../../core/components/shared-chart-interactions/hooks/useSynchronizedSelection.js';
import { getZoomStep } from '../../../core/components/zoom/utils/get-zoom-step.js';
import { useChartInteractions } from '../useChartInteractions.js';
import { useInfiniteZoomConfig } from '../useInfiniteZoomConfig.js';
import { useXScales } from '../useXScale.js';

export const useZoomToSelection = () => {
  const { onZoomChange } = useChartInteractions();
  const { resetSelectionState } = useSynchronizedSelection();

  const { currentScale: xScale, initialScale: initialXScale } = useXScales();
  const infiniteZoom = useInfiniteZoomConfig();
  const setState = useSetState();

  const select = useSelectState();

  return () => {
    if (!select) {
      return;
    }

    resetSelectionState?.();

    const initialDomain = initialXScale.domain();

    const { nextDomain, zoomInEnabled, zoomOutEnabled } = getZoomStep(
      xScale,
      [+initialDomain[0], +initialDomain[1]],
      infiniteZoom,
      select.start.relative.x,
      select.end.relative.x,
      'zoom-x',
    );

    onZoomChange?.(new Date(nextDomain[0]), new Date(nextDomain[1]), 'zoom-x');
    setState(reduceZoomDomain(nextDomain, zoomInEnabled, zoomOutEnabled));
  };
};

export const useSetResetZoomState = () => {
  const setState = useSetState();
  const { onZoomChange } = useChartInteractions();
  const infiniteZoom = useInfiniteZoomConfig();
  const { initialScale } = useXScales();

  return () => {
    const [start, end] = initialScale.domain();
    onZoomChange && onZoomChange(start, end, 'reset');

    setState((prev) =>
      infiniteZoom ? reduceResetToInfiniteZoom(prev) : reduceResetZoom(prev),
    );
  };
};
